import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IPatient } from '@pia/pia.shared';
import { DownloadState, DownloadStepStatus } from 'src/app/emergency/service/emergency-data.resolver';

@Component({
  selector: 'itl-patient-download',
  templateUrl: './patient-download.component.html',
  styleUrls: ['./patient-download.component.scss'],
})
export class PatientDownloadComponent {
  @Input() state: DownloadState;
  @Input() patient: IPatient;

  public DownloadStepStatus = DownloadStepStatus;
  constructor(public _modalCtrl: ModalController) {}
}
